module.exports = __webpack_public_path__ + "assets/elsa-login-pic.d31a5367.svg";